import { render, staticRenderFns } from "./NsTableCol.vue?vue&type=template&id=3c0b77be&"
import script from "./NsTableCol.vue?vue&type=script&lang=js&"
export * from "./NsTableCol.vue?vue&type=script&lang=js&"
import style0 from "./NsTableCol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports